import { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function OrderResult() {
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const { clear } = useCart();
  const sessionId = params.get("session_id");
  const orderId = params.get("order");
  const cancelled = pathname.includes("annule");
  const [state, setState] = useState(sessionId ? "pending" : cancelled ? "cancelled" : "confirmed");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("paid"); clear(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* retry */ }
      if (++tries < 10) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [sessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  const VIEW = {
    pending: { icon: Loader2, spin: true, title: "Vérification du paiement…", text: "Merci de patienter quelques secondes." },
    paid: { icon: CheckCircle2, title: "Paiement confirmé", text: "Merci pour votre confiance. Notre équipe prépare votre commande et vous contacte pour la livraison." },
    confirmed: { icon: CheckCircle2, title: "Commande enregistrée", text: `Votre commande ${orderId ? `n° ${orderId}` : ""} a été transmise. Finalisez la conversation sur WhatsApp — nous confirmons rapidement.` },
    cancelled: { icon: XCircle, title: "Paiement annulé", text: "Aucun montant n'a été débité. Votre panier est conservé." },
    failed: { icon: XCircle, title: "Paiement non abouti", text: "Le paiement a expiré ou échoué. Vous pouvez réessayer." },
    timeout: { icon: Loader2, title: "Vérification en cours", text: "Le statut du paiement n'a pas encore été confirmé. Contactez-nous si besoin." },
  }[state];

  const ok = ["paid", "confirmed"].includes(state);

  return (
    <main data-testid="order-result-page" className="grid min-h-screen place-items-center bg-ice px-4 pt-20">
      <div className="max-w-lg text-center">
        <VIEW.icon className={`mx-auto h-16 w-16 ${VIEW.spin ? "animate-spin text-royal" : ok ? "text-emerald-600" : "text-red-500"}`} />
        <h1 data-testid="order-result-title" className="mt-8 font-display text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">{VIEW.title}</h1>
        <p data-testid="order-result-text" className="mt-5 text-base text-slate-600">{VIEW.text}</p>
        <div className="mt-10 flex justify-center gap-3">
          <Link to="/" data-testid="order-result-home" className="btn-primary">Retour à la boutique</Link>
          {!ok && state !== "pending" && <Link to="/commande" className="btn-outline">Réessayer</Link>}
        </div>
      </div>
    </main>
  );
}
